module.exports = __webpack_public_path__ + "img/2f_l_yanagi@2x.55e7a177.png";